import React from "react"
import { Bookmark } from "lucide-react"
import { Link } from "react-router-dom"
import { STUDENT_QUESTIONS_PATH } from "../../../../component/student/config/studentNavItems"
import "./BookmarksEmpty.style.scss"

const BookmarksEmpty = () => (
  <div className="bookmarks-empty">
    <Bookmark size={48} aria-hidden />
    <h3>No bookmarks yet</h3>
    <p>
      Save questions you find difficult or want to review later by clicking the
      bookmark icon.
    </p>
    <Link to={STUDENT_QUESTIONS_PATH}>Browse question library</Link>
  </div>
)

export default BookmarksEmpty
